import React from "react";
import {withNamespaces} from "react-i18next";
import {claimTypes} from "../../../../constants/claim.constants";
import {connect} from "react-redux";
import SubstringWithDot from "../../../../components/SubstringWithDot";

const WidgetVolumeManagement = ({deviceList, callbackChangeVolume, callbackMuteAction, user, claim, t}) => {

    const claimAccess = user[`c_${claim}`] || null;
    if(claimAccess === claimTypes.NONE) {
        return (
            // return when claims is none
            <React.Fragment/>
        )
    }

    let timer;
    let doneTypingInterval = 500;

    const handleOnChangeSlider = (device) => (e) => {
        const volumeVal = e.target.value;
        const level = document.getElementById('volume' + device.id);
        const btnMute = document.getElementById('btn-mute-' + device.id);
        let mute = device.mute;

        volumeVal > 0 ?
            mute = true :
            mute = false;

        btnMute.className = mute ? 'btn btn-dark' : 'btn btn-danger';
        btnMute.setAttribute('data-toggle', !mute);

        level.innerText = volumeVal;

        clearTimeout(timer);
        timer = setTimeout(() => {
            callbackChangeVolume({
                id: device.id,
                volume: volumeVal
            });
        }, doneTypingInterval);
    };

    const handleClickMuteDevice = (id) => (e) => {
        const btnMute = document.getElementById('btn-mute-' + id);
        const mute = btnMute.getAttribute('data-toggle') === 'true';
        btnMute.className = mute ? 'btn btn-dark' : 'btn btn-danger';
        btnMute.setAttribute('data-toggle', !mute);
        callbackChangeVolume({
            id: id,
            mute: !mute
        });
    };

    const handleGlobalMute = (value) => {
        callbackMuteAction(value ? "muteAll" : "unMuteAll")
    };

    const devices = deviceList?.map((device) => {
        const customMute = !!(device.mute || device.volume === 0);

        return(
            <div className="dvc-space-between col-12 col-sm-6 p-1" key={device.id}>
                <div className="card card-volume">
                    <div className="card-header">
                        <div className="row">
                            <div className="col">
                                <h5 className="card-title device-name w-100">
                                    <SubstringWithDot classNames="desc ws-n" stringData={device.description} numberChar={30} />
                                </h5>
                                <p className="m-0"><small>{ device.label }</small></p>
                            </div>
                            <div className="col">
                                <div className="float-right text-center">
                                    <span className="status">status</span> &nbsp;
                                    <i className={ device.isOnline ? "fas fa-circle status-online" : "fas fa-circle status-offline" }> </i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="hilight-slider">
                            <span>Volume slider:</span>
                            <div className="btn-group float-right">
                                <button
                                    id={"btn-mute-" + device.id}
                                    className={ !customMute ? 'btn btn-dark' : 'btn btn-danger' }
                                    data-toggle={customMute}
                                    title="mute/un mute"
                                    onClick={handleClickMuteDevice(device.id)}>
                                    <i className="fas fa-volume-mute"> </i>
                                </button>
                            </div>

                            <input
                                type="range"
                                min="0"
                                max="100"
                                name={"slider-" + device.id}
                                defaultValue={device.volume}
                                className="slider mt-4"
                                onChange={ handleOnChangeSlider(device) }/>

                            <i className="fas fa-volume-down slider-left-position"> </i>
                            <span className="dvc-volume slider-right-position" id={"volume" + device.id}>{device.volume}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    });


    return (
        <div className="mt-2">
            { devices?.length ? (
                <div className="card">
                    <div className="card-header">
                        <b><span className="card-title"> { t('volume-management') } </span></b>
                    </div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-md-12 p-2">
                                <button id="mute-all" className="btn btn-danger" onClick={() => handleGlobalMute(true)} >
                                    <i className="fas fa-volume-mute"> </i> &nbsp;
                                    &nbsp;
                                    { t('mute-all') }
                                </button>
                                &nbsp;
                                <button id="unmute-all" className="btn btn-default-danger" onClick={() => handleGlobalMute(false)} >
                                    &nbsp;
                                    <i className="fas fa-volume-up"> </i> &nbsp;
                                    { t('unmute-all') }
                                </button>
                            </div>
                        </div>

                        <div className="row">
                            { devices }
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card">
                    <div className="card-header">
                        <b><span className="card-title"> { t('volume-management') } </span></b>
                    </div>
                    <div className="card-body">
                        <div className="text-center p-4">
                            <h3>{ t('volume-management-no-content') }</h3>
                        </div>
                    </div>
                </div>
            ) }
        </div>
    )
};
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetVolumeManagement));
